import React from "react";
import logo from "../../assets/logo.png";
import logoWhite from "../../assets/logo-white.png";

const Logo = (props) => {
  
  return (
    <div>
      {props.versione === "white" ? (
        <img src={logoWhite} style={{width: props.width}} />
      ) : (
        <img src={logo} style={{width: props.width}} />
      )}
    </div>
  );

  // return (
  //   <div>
  // props.versione === "white" ? 
  // (
  //  <img src={logo} style={{width: props.width}} />;
  // ) :
  // (
  //    <img src={logo-white} style={{width: props.width}} />;
  // )
  // </div>
  // )
};

export default Logo;
